import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`
const LegendContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 2px;
  margin-bottom: 1px;
  opacity: ${props => props.active ? '' : '0.3'};
`
const LegendColor = styled.div`
  margin-left: 5px;
  height: 15px;
  width: 15px;
  background-color: ${props => props.color || ''};
`

class CustomizedLegend extends Component {
  renderOptions = () => {
    const options = this.props.payload.map((currentValue, index) => {
      return (
        <LegendContainer active={currentValue.color !== 'gray'} id={currentValue.value} key={index} onClick={this.props.onClick}>
          <span>{currentValue.value}</span>
          <LegendColor color={currentValue.color} />
        </LegendContainer>
      )
    })
    return options
  }

  render() {
    return (
      <Container>
        {this.renderOptions()}
      </Container>
    )
  }
}


export default CustomizedLegend



// WEBPACK FOOTER //
// ./src/Components/ReportsComponents/CustomizedLegend.jsx